import { Pivot, PivotItem } from '@fluentui/react';
import dateformat from 'dateformat';
import { useEffect } from 'react';
import { v4 } from 'uuid';

import { useQuery } from '../../../../../App/history';
import { RootState, useAppSelector } from '../../../../../App/store';
import { actions } from '../../../slice';
import { FormVariables } from '../../../slice/newFormReducers';

export default () => {
  const editingUUID = useAppSelector(editingUUIDSelector);
  const newForms = useAppSelector(newFormsSelector, newFormsEqualityFn);
  const [activeForm, setActiveForm] = useQuery("activeForm");

  const keys = Object.keys(newForms).sort((a, b) => {
    const aO = newForms[a],
      b0 = newForms[b];

    return aO.created! - b0.created!;
  });

  const onItemClick = (item?: PivotItem | undefined) => {
    const itemKey = item?.props.itemKey;
    if (!itemKey) return;

    let uuid = itemKey;

    if (itemKey === "add") {
      uuid = v4();
      actions.createNewForm(uuid);
    }

    setActiveForm(uuid);
  };

  useEffect(() => {
    const isValid = activeForm && keys.includes(activeForm);
    const isSame = editingUUID === activeForm;

    if (isValid && isSame) return;

    if (isValid) {
      actions.focusOnNewForm(activeForm);
    } else if (keys.length !== 0) {
      setActiveForm(keys[keys.length - 1]);
    }
  }, [editingUUID, activeForm]);

  return (
    <Pivot
      selectedKey={editingUUID}
      onLinkClick={onItemClick}
      style={{ marginBottom: "8px" }}
    >
      {keys.map((uuid) => {
        const form = newForms[uuid];

        return (
          <PivotItem
            key={uuid}
            itemKey={uuid}
            headerText={
              form.activeAccount?.displayName ||
              dateformat(form.created, "dd/mm HH:MM")
            }
            itemIcon={form.editingFormId ? "Edit" : "CirclePlus"}
          />
        );
      })}

      <PivotItem itemIcon="Add" itemKey="add" />
    </Pivot>
  );
};

const newFormsEqualityFn = (
  a: { [key: string]: FormVariables },
  b: { [key: string]: FormVariables }
) =>
  Object.keys(a).join() === Object.keys(b).join() &&
  Object.values(a)
    .map((fv) => fv.activeAccount?.displayName)
    .join() ===
    Object.values(b)
      .map((fv) => fv.activeAccount?.displayName)
      .join();
const newFormsSelector = (state: RootState) => state.currentForm.newForms;
const editingUUIDSelector = (state: RootState) =>
  state.currentForm.editingNewFormUUID;
